import * as tslib_1 from "tslib";
import { OnInit, OnChanges, DoCheck, ChangeDetectorRef, SimpleChanges, KeyValueDiffers, KeyValueDiffer, IterableDiffers, IterableDiffer } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartUpdateService, AnalyticsHttpService, AnalyticsExportService, getBarChartOptions, getStackedBarChartOptions, getLineChartOptions, getDoughnutChartOptions, ANALYTICS_COLORS, CHART_UPDATE_DELAY, sortStackedBarChartData, sortBarChartData, limitBarChartData, DEFAULT_CHART_ITEM_LIMIT, calculateFirstDatasetTotal, getDatasetValue, getArrayValue, calculateArrayTotal, getProductValue, getProductTotal, formatProductName, getBreakdownDisplayName as getBreakdownDisplayNameUtil, createConcentricDonutDatasets, createSingleDonutDataset, lightenColor, hexToRgb } from 'app/core/analytics';
var ConsumptionTabComponent = /** @class */ (function () {
    function ConsumptionTabComponent(analyticsHttpService, chartUpdateService, analyticsExportService, cdr, keyValueDiffers, iterableDiffers) {
        this.analyticsHttpService = analyticsHttpService;
        this.chartUpdateService = chartUpdateService;
        this.analyticsExportService = analyticsExportService;
        this.cdr = cdr;
        this.keyValueDiffers = keyValueDiffers;
        this.iterableDiffers = iterableDiffers;
        this.barChartOptions = getBarChartOptions();
        this.stackedBarChartOptions = getStackedBarChartOptions();
        this.lineChartOptions = getLineChartOptions();
        this.productBreakdownDonutChartOptions = getDoughnutChartOptions(false);
        this.barChartColors = [];
        this.donutChartColors = [];
        this.lineChartColors = [];
        this.consumptionBarChartLabels = [];
        this.consumptionBarChartData = [];
        this.consumptionCompareDataArray = [];
        this.consumptionBarChartSort = 'desc';
        this.showAllConsumptionItems = false;
        this.originalConsumptionBarChartLabels = [];
        this.originalConsumptionBarChartData = [];
        this.originalConsumptionCompareDataArray = [];
        this.fullConsumptionBarChartLabels = [];
        this.fullConsumptionBarChartData = [];
        this.fullConsumptionCompareDataArray = [];
        this.consumptionLineChartLabels = [];
        this.consumptionLineChartData = [];
        this.productBreakdownDonutLabels = [];
        this.productBreakdownDonutData = [];
        this.productBreakdownDonutChartKey = 1;
        this.isLoadingConsumption = false;
        this.isLoadingConsumptionOverTime = false;
        this.isDestroyingCharts = false;
        this.filtersDiffer = null;
        this.arrayDiffers = new Map();
        // Mock contextual data mapping for tooltips
        this.contextualDataMap = new Map();
        // Custom tooltip state
        this.tooltipVisible = false;
        this.tooltipX = 0;
        this.tooltipY = 0;
        this.tooltipText = '';
        this.initializeColors();
    }
    ConsumptionTabComponent.prototype.ngOnInit = function () {
        this.filtersDiffer = this.keyValueDiffers.find(this.filters).create();
        this.initializeArrayDiffers();
        this.loadAllData();
    };
    ConsumptionTabComponent.prototype.ngOnChanges = function (changes) {
        if (changes['filters'] && !changes['filters'].firstChange) {
            this.filtersDiffer = this.keyValueDiffers.find(this.filters).create();
            this.initializeArrayDiffers();
            this.loadAllData();
        }
    };
    ConsumptionTabComponent.prototype.ngDoCheck = function () {
        if (this.filtersDiffer) {
            var changes = this.filtersDiffer.diff(this.filters);
            if (changes) {
                this.loadAllData();
                return;
            }
        }
        var arrayKeys = ['drinks', 'distributors', 'markets', 'clients', 'campuses', 'machines', 'products'];
        for (var _i = 0, arrayKeys_1 = arrayKeys; _i < arrayKeys_1.length; _i++) {
            var key = arrayKeys_1[_i];
            var differ = this.arrayDiffers.get(key);
            if (differ) {
                var changes = differ.diff(this.filters[key]);
                if (changes) {
                    this.loadAllData();
                    return;
                }
            }
        }
    };
    ConsumptionTabComponent.prototype.initializeArrayDiffers = function () {
        var arrayKeys = ['drinks', 'distributors', 'markets', 'clients', 'campuses', 'machines', 'products'];
        for (var _i = 0, arrayKeys_2 = arrayKeys; _i < arrayKeys_2.length; _i++) {
            var key = arrayKeys_2[_i];
            this.arrayDiffers.set(key, this.iterableDiffers.find(this.filters[key]).create());
        }
    };
    ConsumptionTabComponent.prototype.initializeColors = function () {
        this.barChartColors = [{
                backgroundColor: ANALYTICS_COLORS.PRIMARY,
                borderColor: ANALYTICS_COLORS.PRIMARY
            }];
        this.donutChartColors = [{
                backgroundColor: Array.from(ANALYTICS_COLORS.PRODUCT),
                hoverBackgroundColor: Array.from(ANALYTICS_COLORS.PRODUCT),
                borderColor: '#ffffff',
                borderWidth: 2
            }];
        this.lineChartColors = [{
                borderColor: ANALYTICS_COLORS.PRODUCT[0],
                backgroundColor: 'rgba(59, 130, 246, 0.1)',
                pointBackgroundColor: ANALYTICS_COLORS.PRODUCT[0],
                pointBorderColor: ANALYTICS_COLORS.PRODUCT[0]
            }];
    };
    ConsumptionTabComponent.prototype.loadAllData = function () {
        this.loadConsumptionData();
        this.loadConsumptionOverTimeData();
    };
    ConsumptionTabComponent.prototype.loadData = function (loadingFlagRef, setLoadingFlag, httpCall, onSuccess, onError, modifyParams) {
        if (loadingFlagRef()) {
            return;
        }
        var queryParams = this.buildQueryParams();
        if (!queryParams) {
            return;
        }
        setLoadingFlag(true);
        if (modifyParams) {
            modifyParams(queryParams);
        }
        if (this.filters.compareEnabled) {
            queryParams.compareEnabled = 'true';
        }
        httpCall(queryParams).subscribe(function (response) {
            setLoadingFlag(false);
            onSuccess(response);
        }, function (error) {
            setLoadingFlag(false);
            if (onError) {
                onError();
            }
        });
    };
    ConsumptionTabComponent.prototype.areCustomDatesReady = function () {
        if (this.filters.datePreset !== 'custom') {
            return true;
        }
        return !!this.filters.startDate && !!this.filters.endDate;
    };
    ConsumptionTabComponent.prototype.buildQueryParams = function () {
        if (!this.areCustomDatesReady()) {
            return null;
        }
        var params = {
            breakdownBy: this.filters.breakdownBy,
            datePreset: this.filters.datePreset
        };
        if (this.filters.datePreset !== 'custom') {
            params.days = this.filters.days;
        }
        else {
            if (this.filters.startDate) {
                params.startDate = this.filters.startDate;
            }
            if (this.filters.endDate) {
                params.endDate = this.filters.endDate;
            }
        }
        if (this.filters.distributors.length > 0) {
            params.distributors = this.filters.distributors.join(',');
        }
        if (this.filters.markets.length > 0) {
            params.markets = this.filters.markets.join(',');
        }
        if (this.filters.clients.length > 0) {
            params.clients = this.filters.clients.join(',');
        }
        if (this.filters.campuses.length > 0) {
            params.campuses = this.filters.campuses.join(',');
        }
        if (this.filters.machines.length > 0) {
            params.machines = this.filters.machines.join(',');
        }
        if (this.filters.products.length > 0) {
            params.products = this.filters.products.join(',');
        }
        if (this.filters.drinks.length > 0) {
            params.drinks = this.filters.drinks.join(',');
        }
        if (this.filters.averageEnabled) {
            params.averageEnabled = 'true';
            params.avgBy = this.filters.avgBy;
        }
        return params;
    };
    ConsumptionTabComponent.prototype.loadConsumptionData = function () {
        var _this = this;
        this.loadData(function () { return _this.isLoadingConsumption; }, function (value) { _this.isLoadingConsumption = value; }, function (params) { return _this.analyticsHttpService.getConsumption(params); }, function (response) { return _this.handleConsumptionResponse(response); }, function () {
            _this.consumptionBarChartLabels = [];
            _this.consumptionBarChartData = [{
                    label: 'Current Period',
                    data: [],
                    borderWidth: 0,
                    stack: 'current'
                }];
            _this.productBreakdownDonutLabels = [];
            _this.productBreakdownDonutData = [];
            _this.productBreakdownDonutChartOptions = getDoughnutChartOptions(false);
            _this.forceUpdateConsumptionChart();
            _this.recreateProductBreakdownDonutChart();
        });
    };
    ConsumptionTabComponent.prototype.parseApiResponse = function (response) {
        if (!response || typeof response !== 'object') {
            return null;
        }
        var responseObj = response;
        var data = (responseObj.data && typeof responseObj.data === 'object' && !Array.isArray(responseObj.data))
            ? responseObj.data
            : responseObj;
        return data;
    };
    /**
     * Extract contextual data from API response
     */
    ConsumptionTabComponent.prototype.extractContextualData = function (data) {
        var contextualData = data.contextualData;
        if (contextualData && typeof contextualData === 'object' && !Array.isArray(contextualData)) {
            return contextualData;
        }
        return undefined;
    };
    ConsumptionTabComponent.prototype.createSimpleBarChartDatasets = function (values, compareData, formattedLabels) {
        var currentBackgroundColor = new Array(values.length).fill(ANALYTICS_COLORS.PRIMARY);
        var currentBorderColor = new Array(values.length).fill(ANALYTICS_COLORS.PRIMARY);
        var currentDataset = {
            label: 'Current Period',
            data: values.slice(),
            backgroundColor: currentBackgroundColor,
            borderColor: currentBorderColor,
            borderWidth: 0,
            stack: 'current'
        };
        var datasets = [currentDataset];
        var hasCompareData = this.filters.compareEnabled &&
            compareData &&
            Array.isArray(compareData) &&
            compareData.length > 0;
        if (hasCompareData && compareData && formattedLabels) {
            var alignedCompareData = formattedLabels.map(function (_, index) {
                if (!compareData || !Array.isArray(compareData)) {
                    return 0;
                }
                return compareData[index] || 0;
            });
            var previousBackgroundColor = new Array(alignedCompareData.length).fill(ANALYTICS_COLORS.PREVIOUS);
            var previousBorderColor = new Array(alignedCompareData.length).fill(ANALYTICS_COLORS.PREVIOUS);
            datasets.push({
                label: 'Previous Period',
                data: alignedCompareData.slice(),
                backgroundColor: previousBackgroundColor,
                borderColor: previousBorderColor,
                borderWidth: 0,
                stack: 'previous'
            });
        }
        return datasets;
    };
    ConsumptionTabComponent.prototype.handleConsumptionResponse = function (response) {
        var data = this.parseApiResponse(response);
        if (!data) {
            this.consumptionBarChartLabels = [];
            this.consumptionBarChartData = [{
                    label: 'Current Period',
                    data: [],
                    borderWidth: 0,
                    stack: 'current'
                }];
            this.productBreakdownDonutLabels = [];
            this.productBreakdownDonutData = [];
            this.productBreakdownDonutChartOptions = getDoughnutChartOptions(false);
            this.forceUpdateConsumptionChart();
            this.recreateProductBreakdownDonutChart();
            return;
        }
        var isSimpleFormat = data.labels && Array.isArray(data.labels) &&
            data.data && Array.isArray(data.data) &&
            !data.datasets;
        if (isSimpleFormat) {
            this.handleSimpleConsumptionResponse(data);
        }
        else if (data.labels && Array.isArray(data.labels) &&
            data.datasets && Array.isArray(data.datasets)) {
            this.handleStackedConsumptionResponse(data);
        }
        else {
            this.consumptionBarChartLabels = [];
            this.consumptionBarChartData = [{
                    label: 'Current Period',
                    data: [],
                    borderWidth: 0,
                    stack: 'current'
                }];
            this.productBreakdownDonutLabels = [];
            this.productBreakdownDonutData = [];
            this.productBreakdownDonutChartOptions = getDoughnutChartOptions(false);
            this.forceUpdateConsumptionChart();
            this.recreateProductBreakdownDonutChart();
            return;
        }
    };
    ConsumptionTabComponent.prototype.handleSimpleConsumptionResponse = function (data) {
        var labels = data.labels || [];
        var values = data.data || [];
        var compareData = data.compareData || data.compare || undefined;
        var breakdownBy = this.filters.breakdownBy;
        var formattedLabels = breakdownBy === 'product'
            ? labels.map(function (label) { return formatProductName(label); })
            : labels.slice();
        this.consumptionBarChartLabels = formattedLabels;
        // Populate contextual data from API response
        var contextualData = this.extractContextualData(data);
        if (contextualData) {
            this.populateContextualData(formattedLabels, contextualData);
        }
        var datasets = this.createSimpleBarChartDatasets(values, compareData, formattedLabels);
        this.consumptionBarChartData = datasets;
        var hasCompareData = this.filters.compareEnabled &&
            compareData &&
            Array.isArray(compareData) &&
            compareData.length > 0;
        if (hasCompareData && datasets.length > 1 && datasets[1].data) {
            this.consumptionCompareDataArray = datasets[1].data.slice();
        }
        else {
            this.consumptionCompareDataArray = [];
        }
        this.originalConsumptionBarChartLabels = formattedLabels.slice();
        this.originalConsumptionBarChartData = datasets.map(function (dataset) { return (tslib_1.__assign({}, dataset, { data: dataset.data.slice() })); });
        this.originalConsumptionCompareDataArray = hasCompareData && this.consumptionCompareDataArray.length > 0
            ? this.consumptionCompareDataArray.slice()
            : [];
        this.sortConsumptionBarChart();
        var colorConfigs = [{
                backgroundColor: ANALYTICS_COLORS.PRIMARY,
                borderColor: ANALYTICS_COLORS.PRIMARY
            }];
        if (hasCompareData) {
            colorConfigs.push({
                backgroundColor: ANALYTICS_COLORS.PREVIOUS,
                borderColor: ANALYTICS_COLORS.PREVIOUS
            });
        }
        this.barChartColors = colorConfigs;
        if (hasCompareData && compareData) {
            var concentricData = createConcentricDonutDatasets(formattedLabels, values, formattedLabels, compareData, Array.from(ANALYTICS_COLORS.PRODUCT));
            this.productBreakdownDonutLabels = concentricData.labels;
            this.productBreakdownDonutData = concentricData.datasets;
        }
        else {
            var transformed = createSingleDonutDataset(formattedLabels, values, Array.from(ANALYTICS_COLORS.PRODUCT));
            this.productBreakdownDonutLabels = transformed.labels;
            this.productBreakdownDonutData = transformed.datasets;
        }
        var hasCompare = this.filters.compareEnabled && this.productBreakdownDonutData.length > 1;
        this.productBreakdownDonutChartOptions = getDoughnutChartOptions(hasCompare);
        this.forceUpdateConsumptionChart();
        this.recreateProductBreakdownDonutChart();
    };
    ConsumptionTabComponent.prototype.handleStackedConsumptionResponse = function (data) {
        var labels = data.labels || [];
        var datasets = data.datasets || [];
        var compareDataObj = data.compare || data.compareData || undefined;
        var compareDatasets = compareDataObj && compareDataObj.datasets || undefined;
        this.consumptionBarChartLabels = labels.slice();
        // Populate contextual data from API response
        var contextualData = this.extractContextualData(data);
        if (contextualData) {
            this.populateContextualData(labels.slice(), contextualData);
        }
        var hasCompareData = this.filters.compareEnabled &&
            compareDatasets &&
            Array.isArray(compareDatasets) &&
            compareDatasets.length > 0;
        var compareDatasetLookup = {};
        if (hasCompareData && compareDatasets) {
            for (var ci = 0; ci < compareDatasets.length; ci++) {
                var compareDataset = compareDatasets[ci];
                var compareLabelRaw = compareDataset.label || '';
                var formattedCompareLabel = formatProductName(compareLabelRaw);
                var compareValues = compareDataset.data || [];
                compareDatasetLookup[formattedCompareLabel] = compareValues.slice();
            }
        }
        var combinedDatasets = [];
        var combinedColors = [];
        this.consumptionCompareDataArray = [];
        var _loop_1 = function (di) {
            var dataset = datasets[di];
            var productData = dataset.data || [];
            var productLabel = dataset.label || "Product " + (di + 1);
            var formattedProductLabel = formatProductName(productLabel);
            var colorIndex = di % ANALYTICS_COLORS.PRODUCT.length;
            var color = ANALYTICS_COLORS.PRODUCT[colorIndex];
            combinedDatasets.push({
                label: formattedProductLabel,
                data: productData.slice(),
                backgroundColor: color,
                borderColor: color,
                borderWidth: 0,
                stack: 'current'
            });
            combinedColors.push({
                backgroundColor: color,
                borderColor: color
            });
            if (hasCompareData) {
                var compareValues_1 = compareDatasetLookup[formattedProductLabel] || [];
                var alignedCompareValues = this_1.consumptionBarChartLabels.map(function (_, labelIndex) {
                    if (!compareValues_1 || !Array.isArray(compareValues_1)) {
                        return 0;
                    }
                    return compareValues_1[labelIndex] || 0;
                });
                var compareColor = lightenColor(color, 0.35);
                combinedDatasets.push({
                    label: formattedProductLabel + ' (Previous)',
                    data: alignedCompareValues,
                    backgroundColor: compareColor,
                    borderColor: compareColor,
                    borderWidth: 0,
                    stack: 'previous'
                });
                combinedColors.push({
                    backgroundColor: compareColor,
                    borderColor: compareColor
                });
            }
        };
        var this_1 = this;
        for (var di = 0; di < datasets.length; di++) {
            _loop_1(di);
        }
        this.consumptionBarChartData = combinedDatasets;
        // Store original unsorted data
        this.originalConsumptionBarChartLabels = labels.slice();
        this.originalConsumptionBarChartData = combinedDatasets.map(function (dataset) { return (tslib_1.__assign({}, dataset, { data: dataset.data.slice() })); });
        this.originalConsumptionCompareDataArray = [];
        this.sortConsumptionBarChart();
        this.barChartColors = combinedColors;
        var productLabels = [];
        var productTotals = [];
        for (var pi = 0; pi < datasets.length; pi++) {
            var dataset = datasets[pi];
            var productLabel = dataset.label || '';
            var formattedProductLabel = formatProductName(productLabel);
            var productData = dataset.data || [];
            var total = productData.reduce(function (sum, value) { return sum + (value || 0); }, 0);
            productLabels.push(formattedProductLabel);
            productTotals.push(total);
        }
        var compareTotals = [];
        if (hasCompareData) {
            for (var ci = 0; ci < productLabels.length; ci++) {
                var label = productLabels[ci];
                var compareValues = compareDatasetLookup[label] || [];
                var compareTotal = compareValues.reduce(function (sum, value) { return sum + (value || 0); }, 0);
                compareTotals.push(compareTotal);
            }
        }
        if (hasCompareData && compareTotals.length === productTotals.length) {
            var concentricData = createConcentricDonutDatasets(productLabels, productTotals, productLabels, compareTotals, Array.from(ANALYTICS_COLORS.PRODUCT));
            this.productBreakdownDonutLabels = concentricData.labels;
            this.productBreakdownDonutData = concentricData.datasets;
        }
        else {
            var transformed = createSingleDonutDataset(productLabels, productTotals, Array.from(ANALYTICS_COLORS.PRODUCT));
            this.productBreakdownDonutLabels = transformed.labels;
            this.productBreakdownDonutData = transformed.datasets;
        }
        var hasCompare = this.filters.compareEnabled && this.productBreakdownDonutData.length > 1;
        this.productBreakdownDonutChartOptions = getDoughnutChartOptions(hasCompare);
        this.forceUpdateConsumptionChart();
        this.recreateProductBreakdownDonutChart();
    };
    ConsumptionTabComponent.prototype.recreateProductBreakdownDonutChart = function () {
        var _this = this;
        this.isDestroyingCharts = true;
        if (this.productBreakdownDonutChart && this.productBreakdownDonutChart.chart) {
            this.productBreakdownDonutChart.chart.destroy();
            this.productBreakdownDonutChart.chart = null;
        }
        this.productBreakdownDonutChartKey = 0;
        this.cdr.markForCheck();
        setTimeout(function () {
            _this.productBreakdownDonutChartKey++;
            _this.cdr.markForCheck();
            _this.isDestroyingCharts = false;
            setTimeout(function () {
                _this.chartUpdateService.updateDonutChart(_this.cdr, {
                    chartInstance: _this.productBreakdownDonutChart,
                    chartKey: _this.productBreakdownDonutChartKey,
                    labels: _this.productBreakdownDonutLabels,
                    datasets: _this.productBreakdownDonutData,
                    chartOptions: _this.productBreakdownDonutChartOptions,
                    chartId: 'productBreakdownDonutChart',
                    activeTab: 'consumption',
                    requiredTab: 'consumption',
                    isDestroyingCharts: _this.isDestroyingCharts
                });
            }, CHART_UPDATE_DELAY);
        }, 50);
    };
    ConsumptionTabComponent.prototype.loadConsumptionOverTimeData = function () {
        var _this = this;
        this.loadData(function () { return _this.isLoadingConsumptionOverTime; }, function (value) { _this.isLoadingConsumptionOverTime = value; }, function (params) { return _this.analyticsHttpService.getConsumptionOverTime(params); }, function (response) { return _this.handleConsumptionOverTimeResponse(response); }, function () {
            _this.consumptionLineChartLabels = [];
            _this.consumptionLineChartData = [];
            _this.forceUpdateConsumptionLineChart();
        }, function (params) {
            delete params.breakdownBy;
            if (_this.filters.averageEnabled && _this.filters.avgBy) {
                params.avgBy = _this.filters.avgBy;
            }
            else {
                params.avgBy = 'day';
            }
            if (_this.filters.compareEnabled) {
                params.compare = 'true';
            }
        });
    };
    ConsumptionTabComponent.prototype.handleConsumptionOverTimeResponse = function (response) {
        var _this = this;
        var data = this.parseApiResponse(response);
        if (!data) {
            this.consumptionLineChartLabels = [];
            this.consumptionLineChartData = [];
            this.forceUpdateConsumptionLineChart();
            return;
        }
        var labels = data.labels || [];
        var datasets = data.datasets || [];
        var compareData = data.compare;
        var compareLabels = compareData ? compareData.labels || [] : [];
        var dateRange = data.dateRange;
        var compareDateRange = data.compareDateRange;
        var chartLabelCount = labels.length;
        var shouldAlignCompare = !this.filters.averageEnabled || (this.filters.avgBy || 'day') === 'day';
        this.consumptionLineChartLabels = labels.slice();
        this.consumptionLineChartData = datasets.map(function (dataset, index) {
            var productData = dataset.data || [];
            var productLabel = dataset.label || "Product " + (index + 1);
            var formattedProductLabel = formatProductName(productLabel);
            var colorIndex = index % ANALYTICS_COLORS.PRODUCT.length;
            var color = ANALYTICS_COLORS.PRODUCT[colorIndex];
            return {
                label: formattedProductLabel,
                data: productData.slice(),
                borderColor: color,
                backgroundColor: "rgba(" + hexToRgb(color) + ", 0.1)",
                pointBackgroundColor: color,
                pointBorderColor: color,
                fill: false,
                borderWidth: 2,
                pointRadius: 2,
                pointHoverRadius: 4,
                lineTension: 0.4
            };
        });
        if (this.filters.compareEnabled && compareData) {
            var compareDatasets = compareData.datasets || [];
            compareDatasets.forEach(function (compareDataset, index) {
                var productLabel = compareDataset.label || "Product " + (index + 1);
                var formattedProductLabel = formatProductName(productLabel);
                var compareProductData = compareDataset.data || [];
                var compareValuesAdjusted = shouldAlignCompare
                    ? _this.alignSeriesWithOffset(compareProductData, _this.getCompareAlignmentOffset(dateRange, compareDateRange, labels, compareLabels), chartLabelCount)
                    : _this.normalizeSeriesLength(compareProductData, chartLabelCount);
                var matchingIndex = _this.consumptionLineChartData.findIndex(function (ds) { return ds.label === formattedProductLabel; });
                var colorIndex = matchingIndex >= 0 ? matchingIndex % ANALYTICS_COLORS.PRODUCT.length : index % ANALYTICS_COLORS.PRODUCT.length;
                var baseColor = ANALYTICS_COLORS.PRODUCT[colorIndex];
                var compareColor = lightenColor(baseColor, 0.3);
                _this.consumptionLineChartData.push({
                    label: formattedProductLabel + " (Previous)",
                    data: compareValuesAdjusted,
                    borderColor: compareColor,
                    backgroundColor: "rgba(" + hexToRgb(compareColor) + ", 0.1)",
                    pointBackgroundColor: compareColor,
                    pointBorderColor: compareColor,
                    fill: false,
                    borderWidth: 2,
                    borderDash: [5, 5],
                    pointRadius: 2,
                    pointHoverRadius: 4,
                    lineTension: 0.4
                });
            });
        }
        var trimmed = this.trimZeroOnlyPoints(this.consumptionLineChartLabels, this.consumptionLineChartData);
        this.consumptionLineChartLabels = trimmed.labels;
        this.consumptionLineChartData = trimmed.datasets;
        this.lineChartColors = this.consumptionLineChartData.map(function (dataset) { return ({
            borderColor: typeof dataset.borderColor === 'string' ? dataset.borderColor : ANALYTICS_COLORS.PRODUCT[0],
            backgroundColor: typeof dataset.backgroundColor === 'string' ? dataset.backgroundColor : 'rgba(59, 130, 246, 0.1)',
            pointBackgroundColor: typeof dataset.pointBackgroundColor === 'string' ? dataset.pointBackgroundColor : ANALYTICS_COLORS.PRODUCT[0],
            pointBorderColor: typeof dataset.pointBorderColor === 'string' ? dataset.pointBorderColor : ANALYTICS_COLORS.PRODUCT[0]
        }); });
        this.forceUpdateConsumptionLineChart();
    };
    ConsumptionTabComponent.prototype.forceUpdateConsumptionLineChart = function () {
        var _this = this;
        var tempLabels = this.consumptionLineChartLabels.slice();
        var tempDatasets = this.consumptionLineChartData.map(function (ds) { return (tslib_1.__assign({}, ds)); });
        this.consumptionLineChartLabels = [];
        this.consumptionLineChartData = [];
        this.cdr.detectChanges();
        setTimeout(function () {
            _this.consumptionLineChartLabels = tempLabels;
            _this.consumptionLineChartData = tempDatasets;
            _this.cdr.detectChanges();
        }, 10);
    };
    ConsumptionTabComponent.prototype.getCompareAlignmentOffset = function (dateRange, compareDateRange, currentLabels, compareLabels) {
        var rangeStart = dateRange && dateRange.startDate ? new Date(dateRange.startDate) : null;
        var compareRangeStart = compareDateRange && compareDateRange.startDate
            ? new Date(compareDateRange.startDate)
            : null;
        var rangeOffset = this.calculateDayOffset(rangeStart, compareRangeStart);
        if (rangeOffset !== null) {
            return rangeOffset;
        }
        var firstCurrentLabel = currentLabels && currentLabels.length > 0 ? currentLabels[0] : undefined;
        var firstCompareLabel = compareLabels && compareLabels.length > 0 ? compareLabels[0] : undefined;
        var currentLabelDate = this.parseLabelToDate(firstCurrentLabel);
        var compareLabelDate = this.parseLabelToDate(firstCompareLabel);
        var labelOffset = this.calculateDayOffset(currentLabelDate, compareLabelDate);
        return labelOffset !== null ? labelOffset : 0;
    };
    ConsumptionTabComponent.prototype.calculateDayOffset = function (currentDate, compareDate) {
        if (!currentDate || !compareDate || Number.isNaN(currentDate.getTime()) || Number.isNaN(compareDate.getTime())) {
            return null;
        }
        var MS_PER_DAY = 24 * 60 * 60 * 1000;
        return Math.round((currentDate.getTime() - compareDate.getTime()) / MS_PER_DAY);
    };
    ConsumptionTabComponent.prototype.alignSeriesWithOffset = function (series, offset, targetLength) {
        if (targetLength <= 0) {
            return [];
        }
        var aligned = new Array(targetLength).fill(0);
        for (var i = 0; i < targetLength; i++) {
            var sourceIndex = i - offset;
            if (sourceIndex >= 0 && sourceIndex < series.length) {
                aligned[i] = series[sourceIndex];
            }
            else {
                aligned[i] = 0;
            }
        }
        return aligned;
    };
    ConsumptionTabComponent.prototype.normalizeSeriesLength = function (series, targetLength) {
        if (targetLength <= 0) {
            return [];
        }
        if (series.length === targetLength) {
            return series.slice();
        }
        if (series.length > targetLength) {
            return series.slice(series.length - targetLength);
        }
        var result = new Array(targetLength).fill(0);
        var startIndex = targetLength - series.length;
        for (var i = 0; i < series.length; i++) {
            result[startIndex + i] = series[i];
        }
        return result;
    };
    ConsumptionTabComponent.prototype.parseLabelToDate = function (label) {
        if (!label) {
            return null;
        }
        var parsed = new Date(label);
        if (!Number.isNaN(parsed.getTime())) {
            return parsed;
        }
        var fallback = new Date(label + " " + new Date().getFullYear());
        if (!Number.isNaN(fallback.getTime())) {
            return fallback;
        }
        return null;
    };
    ConsumptionTabComponent.prototype.trimZeroOnlyPoints = function (labels, datasets) {
        if (labels.length === 0 || datasets.length === 0) {
            return { labels: labels, datasets: datasets };
        }
        var firstNonZeroIndex = -1;
        var lastNonZeroIndex = -1;
        var _loop_2 = function (i) {
            var hasValue = datasets.some(function (dataset) {
                var dataArray = dataset.data;
                if (!Array.isArray(dataArray) || dataArray.length <= i) {
                    return false;
                }
                var value = dataArray[i];
                return typeof value === 'number' && value !== 0;
            });
            if (hasValue) {
                if (firstNonZeroIndex === -1) {
                    firstNonZeroIndex = i;
                }
                lastNonZeroIndex = i;
            }
        };
        for (var i = 0; i < labels.length; i++) {
            _loop_2(i);
        }
        if (firstNonZeroIndex === -1 || lastNonZeroIndex === -1) {
            return {
                labels: [],
                datasets: datasets.map(function (dataset) { return (tslib_1.__assign({}, dataset, { data: [] })); })
            };
        }
        var trimmedLabels = labels.slice(firstNonZeroIndex, lastNonZeroIndex + 1);
        var trimmedDatasets = datasets.map(function (dataset) {
            var dataArray = Array.isArray(dataset.data) ? dataset.data : [];
            return tslib_1.__assign({}, dataset, { data: dataArray.slice(firstNonZeroIndex, lastNonZeroIndex + 1) });
        });
        return {
            labels: trimmedLabels,
            datasets: trimmedDatasets
        };
    };
    ConsumptionTabComponent.prototype.toggleConsumptionBarChartSort = function () {
        this.consumptionBarChartSort = this.consumptionBarChartSort === 'desc' ? 'asc' : 'desc';
        this.sortConsumptionBarChart();
        this.forceUpdateConsumptionChart();
    };
    ConsumptionTabComponent.prototype.sortConsumptionBarChart = function () {
        var isStacked = this.filters.breakdownBy !== 'product';
        var labelsToSort = this.originalConsumptionBarChartLabels.length > 0
            ? this.originalConsumptionBarChartLabels
            : this.consumptionBarChartLabels;
        var dataToSort = this.originalConsumptionBarChartData.length > 0
            ? this.originalConsumptionBarChartData
            : this.consumptionBarChartData;
        var compareDataToSort = this.originalConsumptionCompareDataArray.length > 0
            ? this.originalConsumptionCompareDataArray
            : this.consumptionCompareDataArray;
        if (isStacked) {
            var result = sortStackedBarChartData(labelsToSort, dataToSort, this.consumptionBarChartSort);
            this.fullConsumptionBarChartLabels = result.labels;
            this.fullConsumptionBarChartData = result.datasets;
            this.fullConsumptionCompareDataArray = [];
        }
        else {
            var result = sortBarChartData(labelsToSort, dataToSort, compareDataToSort.length > 0 ? compareDataToSort : undefined, this.consumptionBarChartSort, this.filters.compareEnabled);
            this.fullConsumptionBarChartLabels = result.labels;
            this.fullConsumptionBarChartData = result.datasets;
            this.fullConsumptionCompareDataArray = result.compareData;
        }
        this.updateConsumptionDisplayData();
    };
    ConsumptionTabComponent.prototype.updateConsumptionDisplayData = function () {
        var limit = this.showAllConsumptionItems
            ? this.fullConsumptionBarChartLabels.length
            : DEFAULT_CHART_ITEM_LIMIT;
        var result = limitBarChartData(this.fullConsumptionBarChartLabels, this.fullConsumptionBarChartData, this.fullConsumptionCompareDataArray.length > 0 ? this.fullConsumptionCompareDataArray : undefined, limit, false);
        this.consumptionBarChartLabels = result.labels;
        this.consumptionBarChartData = result.datasets;
        this.consumptionCompareDataArray = result.compareData;
    };
    ConsumptionTabComponent.prototype.toggleShowAllConsumptionItems = function () {
        this.showAllConsumptionItems = !this.showAllConsumptionItems;
        this.updateConsumptionDisplayData();
        this.forceUpdateConsumptionChart();
    };
    ConsumptionTabComponent.prototype.forceUpdateConsumptionChart = function () {
        var _this = this;
        this.chartUpdateService.recreateBarChart(this.cdr, function () { return ({
            labels: _this.consumptionBarChartLabels,
            datasets: _this.consumptionBarChartData,
            compareData: _this.consumptionCompareDataArray
        }); }, function (data) {
            _this.consumptionBarChartLabels = data.labels;
            _this.consumptionBarChartData = data.datasets;
            _this.consumptionCompareDataArray = data.compareData;
        }, 'ConsumptionBarChart');
    };
    ConsumptionTabComponent.prototype.shouldShowConsumptionToggle = function () {
        return this.fullConsumptionBarChartLabels.length > DEFAULT_CHART_ITEM_LIMIT;
    };
    ConsumptionTabComponent.prototype.getConsumptionToggleLabel = function () {
        if (this.showAllConsumptionItems) {
            return this.consumptionBarChartSort === 'desc' ? 'Top 10' : 'Bottom 10';
        }
        return 'All';
    };
    ConsumptionTabComponent.prototype.getConsumptionToggleTitle = function () {
        if (this.showAllConsumptionItems) {
            return this.consumptionBarChartSort === 'desc' ? 'Show top 10' : 'Show bottom 10';
        }
        return 'Show all';
    };
    ConsumptionTabComponent.prototype.getBarChartOptions = function (stacked) {
        return stacked ? this.stackedBarChartOptions : this.barChartOptions;
    };
    ConsumptionTabComponent.prototype.getConsumptionBarChartTotal = function () {
        return calculateFirstDatasetTotal(this.consumptionBarChartData);
    };
    ConsumptionTabComponent.prototype.getConsumptionValue = function (index) {
        if (!this.consumptionBarChartData || this.consumptionBarChartData.length === 0) {
            return 0;
        }
        return getDatasetValue(this.consumptionBarChartData[0], index);
    };
    ConsumptionTabComponent.prototype.isConsumptionStacked = function () {
        return this.filters.breakdownBy !== 'product';
    };
    ConsumptionTabComponent.prototype.hasConsumptionCompareData = function () {
        return this.filters.compareEnabled &&
            this.consumptionCompareDataArray &&
            this.consumptionCompareDataArray.length > 0;
    };
    ConsumptionTabComponent.prototype.getConsumptionCompareValue = function (index) {
        return getArrayValue(this.consumptionCompareDataArray, index);
    };
    ConsumptionTabComponent.prototype.getConsumptionCompareTotal = function () {
        return calculateArrayTotal(this.consumptionCompareDataArray);
    };
    ConsumptionTabComponent.prototype.getConsumptionValueForProduct = function (productIndex, labelIndex) {
        return getProductValue(this.consumptionBarChartData, productIndex, labelIndex);
    };
    ConsumptionTabComponent.prototype.getConsumptionTotalForProduct = function (productIndex) {
        return getProductTotal(this.consumptionBarChartData, productIndex);
    };
    ConsumptionTabComponent.prototype.getBreakdownDisplayName = function (option) {
        return getBreakdownDisplayNameUtil(option);
    };
    ConsumptionTabComponent.prototype.hasInsufficientTimeseriesData = function (labels) {
        return labels.length === 1;
    };
    ConsumptionTabComponent.prototype.hasNoData = function (labels, datasets) {
        return labels.length === 0 || datasets.length === 0 || (datasets.length > 0 && datasets[0].data.length === 0);
    };
    /**
     * Get tooltip text for a label based on breakdown type
     */
    ConsumptionTabComponent.prototype.getContextualTooltip = function (label) {
        var breakdownBy = this.filters.breakdownBy;
        var context = this.contextualDataMap.get(label);
        if (!context) {
            return '';
        }
        if (breakdownBy === 'client') {
            // Show Partner
            return context.partner ? "Partner: " + context.partner : '';
        }
        else if (breakdownBy === 'campus') {
            // Show Partner first, then Client
            var parts = [];
            if (context.partner) {
                parts.push("Partner: " + context.partner);
            }
            if (context.client) {
                parts.push("Client: " + context.client);
            }
            return parts.join('\n');
        }
        else if (breakdownBy === 'machine') {
            // Show Partner first, then Client, then Campus
            var parts = [];
            if (context.partner) {
                parts.push("Partner: " + context.partner);
            }
            if (context.client) {
                parts.push("Client: " + context.client);
            }
            if (context.campus) {
                parts.push("Campus: " + context.campus);
            }
            return parts.join('\n');
        }
        return '';
    };
    /**
     * Check if tooltip should be shown based on breakdown type
     */
    ConsumptionTabComponent.prototype.shouldShowContextualTooltip = function () {
        var breakdownBy = this.filters.breakdownBy;
        return breakdownBy === 'client' || breakdownBy === 'campus' || breakdownBy === 'machine';
    };
    /**
     * Show custom tooltip on mouse enter
     */
    ConsumptionTabComponent.prototype.onTooltipMouseEnter = function (event, label) {
        if (!this.shouldShowContextualTooltip()) {
            return;
        }
        var tooltipText = this.getContextualTooltip(label);
        if (!tooltipText) {
            return;
        }
        this.tooltipVisible = true;
        this.tooltipText = tooltipText;
        // Set position once on enter - tooltip stays static
        this.tooltipX = event.clientX;
        this.tooltipY = event.clientY - 10; // 10px above cursor
    };
    /**
     * Hide tooltip on mouse leave
     */
    ConsumptionTabComponent.prototype.onTooltipMouseLeave = function () {
        this.tooltipVisible = false;
    };
    /**
     * Populate contextual data from API response
     */
    ConsumptionTabComponent.prototype.populateContextualData = function (labels, contextualData) {
        var _this = this;
        var breakdownBy = this.filters.breakdownBy;
        // Only populate for client, campus, or machine breakdowns
        if (breakdownBy !== 'client' && breakdownBy !== 'campus' && breakdownBy !== 'machine') {
            return;
        }
        // Clear existing contextual data for these labels
        labels.forEach(function (label) {
            _this.contextualDataMap.delete(label);
        });
        // Populate from API response
        labels.forEach(function (label) {
            var contextData = contextualData[label];
            if (contextData) {
                var context = {};
                if (contextData.partner) {
                    context.partner = contextData.partner;
                }
                if (contextData.client) {
                    context.client = contextData.client;
                }
                if (contextData.campus) {
                    context.campus = contextData.campus;
                }
                // Only set if we have at least one property
                if (context.partner || context.client || context.campus) {
                    _this.contextualDataMap.set(label, context);
                }
            }
        });
    };
    /**
     * Check if data is available for export
     * Check both full and limited arrays to handle all breakdown scenarios
     */
    ConsumptionTabComponent.prototype.hasData = function () {
        // Check limited arrays (what's currently displayed)
        var hasLimitedData = this.consumptionBarChartLabels.length > 0 &&
            this.consumptionBarChartData.length > 0 &&
            (this.consumptionBarChartData[0] && this.consumptionBarChartData[0].data && this.consumptionBarChartData[0].data.length > 0);
        // Check full arrays (all data, including when "show all" is available)
        var hasFullData = this.fullConsumptionBarChartLabels.length > 0 &&
            this.fullConsumptionBarChartData.length > 0 &&
            (this.fullConsumptionBarChartData[0] && this.fullConsumptionBarChartData[0].data && this.fullConsumptionBarChartData[0].data.length > 0);
        return hasLimitedData || hasFullData;
    };
    /**
     * Export consumption table to Excel
     */
    ConsumptionTabComponent.prototype.exportTable = function () {
        try {
            // Use full arrays for export (all data, not just visible)
            var labels = this.fullConsumptionBarChartLabels.length > 0
                ? this.fullConsumptionBarChartLabels
                : this.consumptionBarChartLabels;
            // Safely extract data, handling single-row cases
            var data = [];
            if (this.fullConsumptionBarChartData.length > 0) {
                data = this.fullConsumptionBarChartData;
            }
            else if (this.consumptionBarChartData.length > 0) {
                data = this.consumptionBarChartData;
            }
            var compareData = this.filters.compareEnabled && this.fullConsumptionCompareDataArray.length > 0
                ? this.fullConsumptionCompareDataArray
                : (this.filters.compareEnabled && this.consumptionCompareDataArray.length > 0
                    ? this.consumptionCompareDataArray
                    : undefined);
            // Ensure labels and data arrays have matching lengths
            if (labels.length === 0 || data.length === 0) {
                console.warn('No data available for export');
                return;
            }
            var exportData = {
                labels: labels,
                data: data,
                compareData: compareData,
                isStacked: this.isConsumptionStacked(),
                breakdownBy: this.filters.breakdownBy,
                total: this.getConsumptionBarChartTotal(),
                compareTotal: this.filters.compareEnabled ? this.getConsumptionCompareTotal() : undefined
            };
            this.analyticsExportService.exportConsumptionTable(exportData, this.filters, 'Consumption', this.drinkOptions, this.productOptions, this.distributorOptions, this.marketOptions, this.clientOptions, this.campusOptions, this.machineOptions);
        }
        catch (error) {
            console.error('Error exporting consumption table:', error);
            throw error;
        }
    };
    return ConsumptionTabComponent;
}());
export { ConsumptionTabComponent };
